<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <b-container>
        <b-alert show variant="info" class="mt20">
            <!-- <h4 class="alert-heading">提示</h4> -->

            <div v-html="promptMsg"></div>
            <hr />
            <b-button variant="outline-primary" href="/options_detail" :disabled="expired">新增申请</b-button>
            <!-- <b-badge variant="danger" v-if="!showPrompt" style="margin-left:10px">申请已结束，无法申请</b-badge> -->
        </b-alert>

        <b-modal ref="my-modal" v-model="stateDetailVisible" ok-title="关闭" ok-only title="详情">
            <div v-for="item in stateDetailSelect" style="margin-bottom:20px">
                <span style="margin-right:20px">{{ item.time }}</span>
                <b-badge variant="primary" v-if="item.sts == 0">提交审核</b-badge>
                <b-badge variant="danger" v-if="item.sts == 1">审核不通过</b-badge>
                <b-badge variant="secondary" v-if="item.sts == 2">审核通过</b-badge>
                <b-badge variant="primary" v-if="item.sts == 3">再次提交审核</b-badge>
                <!-- <b-badge variant="black" v-if="item.sts == 1" style="margin-left:5px"> -->
                <div v-if="item.sts == 1" style="font-size:10px;font-weight:bold">{{ item.reason }}</div>
                <!-- </b-badge> -->
            </div>
        </b-modal>

        <b-row class="mt20">
            <b-col lg="4" xl="4" sm="12" md="4">
                <b-breadcrumb :items="bread"></b-breadcrumb>
            </b-col>

            <b-col lg="2" xl="2" sm="3" md="2">
                <b-form-select v-if="false" v-model="selectedTheme" :options="tableTheme"
                    placeholder="请选择表主题"></b-form-select>
            </b-col>

            <b-col lg="2" xl="2" sm="3" md="2">
                <b-form-select v-model="reqBody.applyNo" :options="years" placeholder="请选择年份"
                    @change="requestApply(true)"></b-form-select>
            </b-col>

            <b-col lg="4" xl="4" sm="6" md="4">
                <b-input-group style="float: right">
                    <b-form-input placeholder="输入项目名搜索" v-model="keyword"></b-form-input>
                    <b-input-group-append>
                        <b-button variant="primary" @click="requestApply(true)">搜索</b-button>
                    </b-input-group-append>
                </b-input-group>
            </b-col>
        </b-row>

        <b-spinner variant="primary" label="Spinning" v-if="loading"></b-spinner>

        <h3 v-if="!loading && items.length == 0">没有查询到申请记录</h3>

        <b-alert show variant="info" class="mt20">
            提示：将审核通过的电子申请表打印、按申请表内要求签字并加盖单位公章后扫描生成PDF版发送到联系邮箱（d06_haiyang@nsfc.gov.cn）
        </b-alert>

        <b-table class="mt10" bordered style="text-align: left" responsive hover :items="items" :fields="fields"
            :dark="selectedTheme == 2" v-if="items.length > 0">
            <!--dark-->

            <template v-slot:cell(projName)="data">
                {{ placement }}
                <p class="proj-name" :id="`popover-1-${data.item.key}`">{{ data.item.projName }}</p>
                <b-popover style="background-color: #0f6674" :target="`popover-1-${data.item.key}`" title="项目名称"
                    triggers="hover">
                    <template v-slot:title>项目名称</template>
                    <div>{{ data.item.projName }}</div>
                </b-popover>
            </template>

            <template v-slot:cell(prjName)="data">
                <div style="width:170px">{{ data.item.prjName }}</div>
            </template>

            <template v-slot:cell(ocnArea)="data">
                <div style="width:150px">{{ data.item.ocnArea }}</div>
            </template>

            <template v-slot:cell(operate)="data">
                <div>
                    <b-button class="opButton" @click="goDetail(999, data.item)" variant="outline-primary"
                        size="sm">查看</b-button>

                    <b-button class="opButton" variant="outline-primary" v-if="data.item.state == 1" size="sm"
                        @click="goDetail(3, data.item)" :disabled="expired">重新提交</b-button>

                    <b-button class="opButton" variant="outline-primary"
                        v-if="data.item.state == 0 || data.item.state == 3" size="sm"
                        @click="goDetail(data.state, data.item)" :disabled="expired">修改</b-button>

                    <b-button class="opButton" variant="outline-primary" size="sm"
                        @click="showStateDetail(data)">状态详情</b-button>
                    <b-button v-if="data.item.state == 2" class="opButton" variant="outline-primary" size="sm"
                        @click="downloadPdf(data.item)">下载pdf</b-button>
                </div>
            </template>

            <template v-slot:cell(c)="data">
                <b-badge variant="primary" v-if="data.item.state == 0">审核中</b-badge>
                <b-badge variant="danger" v-if="data.item.state == 1"> 审核不通过 </b-badge>
                <b-badge variant="secondary" v-if="data.item.state == 2">已审核</b-badge>
                <b-badge variant="primary" v-if="data.item.state == 3">再次审核中</b-badge>

                <!--退回原因-->
                <b-button v-if="data.item.state == 1" style="color:red; border-color: red;" class="opButton"
                    variant="outline-primary" size="sm" :id="`pop-reason-${data.item.id}`">退回原因</b-button>
                <b-popover v-if="data.item.state == 1" :target="`pop-reason-${data.item.id}`" placement="lefttop"
                    :title="退回原因" triggers="hover" :content="getReason(data.item.statusTime)"></b-popover>
            </template>

            <template v-slot:cell(inpTime)="data">
                <p>{{ data.item.inpTime }}</p>
            </template>

            <template v-slot:cell(unitName)="data">
                <p style="width:140px">{{ data.item.unitName }}</p>
            </template>

            <template v-slot:cell(sbjNum)="data">
                <p style="width:120px">{{ data.item.sbjNum }}</p>
            </template>
        </b-table>

        <b-pagination v-if="items.length > 0" align="center" class="mt20" :number-of-pages="pagination.totalPage"
            :value="pagination.page" :total-rows="pagination.total" :per-page="reqBody.pageSize" base-url="#"
            first-text="首页" prev-text="上一页" next-text="下一页" last-text="末页" first-number last-number
            @change="pageChangeListener"></b-pagination>

        <link-component></link-component>


    </b-container>
</template>

<script>
import LinkComponent from '@/components/LinkComponent.vue';
import { axiosServer } from '@/api/judge';
import { urls } from '@/api/urls';
import Vue from 'vue';
import { requestSvApply } from '@/api/SvpConfig';
import htmlToPdf from '../../utils/htmlToPdf';
import { formatDate } from '@/utils/date';

export default {
    components: { LinkComponent },
    name: 'option',
    props: {},
    computed: {
        years: function () {
            // 获取当前年份
            var date = new Date();
            var year = date.getFullYear();
            var years = [];
            // 生成从2015至今年的年份列表
            for (var i = 2015; i <= year + 2; i++) {
                years.push({ value: i, text: i });
            }
            // 倒序排列
            years.reverse();

            // 在起始位置插入全部年份
            years.unshift({ value: null, text: '全部年份' });

            return years;
        }
    },
    data() {
        return {
            selectPdfInfo: [],
            pdfItem: {},
            stateDetailSelect: {},
            stateDetailVisible: false,
            fields: [
                { key: 'applyNo', label: '申请号' },
                { key: 'prjNum', label: '项目批准号' },
                { key: 'prjName', label: '项目名称' },
                { key: 'ocnArea', label: '海区' },
                { key: 'unitName', label: '依托单位（全称）' },
                { key: 'inpTime', label: '提交时间' },
                { key: 'c', label: '状态' },
                { key: 'operate', label: '操作' }
            ],

            fields2: [
                { key: 'key1', label: '申请号', thClass: 'd-done' },
                { key: 'value1', label: '项目批准号', thClass: 'd-done' }
            ],
            items: [],

            bread: [
                {
                    text: '首页',
                    href: '/index'
                },
                {
                    text: '搭载需求申请'
                }
            ],

            // yearSelected: null,
            selectedTheme: 1,

            tableTheme: [
                { value: '1', text: '白色主题' },
                { value: '2', text: '黑色主题' }
            ],
            reqBody: { page: 1, pageSize: 10, applyNo: null, prjName: '' }, //参数变量存值
            keyword: '', //搜索输入框绑定数据
            pagination: {},
            promptMsg: '',
            expired: true,
            loading: false
        };
    },
    activated() {
        this.checkLogin();
        requestSvApply().then(resp => {
            this.promptMsg = resp.content;
            this.expired = resp.expired;
        });
    },
    mounted() {
        this.checkLogin();
    },
    methods: {
        downloadPdf(item) {
            let routeUrl = this.$router.resolve({
                path: '/applyPdf',
                query: { applyId: item.id }
            });
            window.open(routeUrl.href, '_blank', 'width=1186px,height=832px,top=0px,left=0px');
        },
        showStateDetail(data) {
            this.stateDetailSelect = JSON.parse(data.item.statusTime);
            this.stateDetailVisible = true;
        },
        goDetail(code, data) {
            this.$router.push({ name: 'options_detail', query: { code: code, applyId: data.id } });
        },
        checkLogin() {
            let loginName = Vue.ls.get('token');
            if (loginName) {
                this.requestApply(false);
            } else {
                //页面加载完成时请求数据
                this.$router.push({ name: 'login', query: { tip: 1, redirectUrl: 'options', msg: '访问搭载需求征集页面需要先登录' } });
            }
        },
        //请求搭载需求申请数据
        requestApply(isSearchBtnClick) {
            if (isSearchBtnClick) {
                this.reqBody.page = 1;
                this.reqBody.prjName = this.keyword;
            }

            this.loading = true;
            axiosServer({
                url: urls.apply,
                params: this.reqBody //将参数设置为变量
            })
                .then(resp => {
                    this.loading = false;
                    this.items = resp.data.page.list;
                    let page = resp.data.page;
                    this.pagination = {
                        page: page.page + 1,
                        pageSize: page.pageSize,
                        total: page.total,
                        totalPage: page.totalPage
                    };
                })
                .catch(e => {
                    this.loading = false;
                });
        },

        pageChangeListener(page) {
            this.reqBody.page = page;
            this.requestApply();
        },
        // 获取退回原因
        getReason(statusTime) {
            let reason = '';
            if (statusTime) {
                let statusTimeArr = JSON.parse(statusTime);
                // statusTimeArr 倒序查找第一个 reason 不为空的项
                for (let i = statusTimeArr.length - 1; i >= 0; i--) {
                    if (statusTimeArr[i].reason) {
                        reason = statusTimeArr[i].reason;
                        break;
                    }
                }
            }
            return reason;
        }
    }
};
</script>

<style>
.pdf-line {
    width: 592.28px;
    padding: 3px;
}

.pdf-title {
    display: inline-block;
    min-width: 80px !important;
    font-weight: bold;
    margin-left: 30px;
    margin-right: 10px;
}

.pdf-content {
    font-family: sans-serif;
}

#printModal___BV_modal_body_ {
    padding: 0px;
}

#pdfDom thead {
    visibility: hidden;
}

.modalclass {
    width: 610px;
}
</style>

<style scoped>
.title-class2 {
    min-width: 130px;
}

.opButton {
    padding: 2px;
    width: 65px;
    margin-left: 5px;
    margin-top: 5px;
}

.proj-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 300px;
    padding: 0px;
    margin-bottom: 0px;
}

/* 响应式布局：方案不同屏幕尺寸分别使用不同的CSS样式 */
@media (max-width: 575.99px) {
    .form-style {
        text-align: left;
        width: 100%;
    }

    .botton-row {
        margin-bottom: 20px;
    }
}

@media (min-width: 576px) {
    .form-style {
        text-align: left;
        width: 100%;
    }

    .botton-row {
        margin-bottom: 20px;
    }
}

@media (min-width: 768px) {
    .form-style {
        text-align: left;
        width: 70%;
        margin: 0 auto;
    }

    .botton-row {
        margin-bottom: 20px;
        padding: 0 50px;
    }
}

@media (min-width: 992px) {
    .form-style {
        text-align: left;
        width: 70%;
        margin: 0 auto;
    }

    .botton-row {
        margin-bottom: 20px;
        padding: 0 100px;
    }
}

@media (min-width: 1200px) {
    .form-style {
        text-align: left;
        width: 70%;
        margin: 0 auto;
    }

    .botton-row {
        margin-bottom: 20px;
        padding: 0 200px;
    }
}
</style>
